import React from "react";
import { americanExpress, discovery, masterCard, visa } from "../assets/images";

const getCreditCardKindIcon = (title: string): JSX.Element => {
  switch (title) {
    case "Visa":
      return <img src={visa} alt="visa" />;
    case "MasterCard":
      return <img src={masterCard} alt="masterCard" />;
    case "AmericanExpress":
      return <img src={americanExpress} alt="americanExpress" />;
    case "Discover":
      return <img src={discovery} alt="discover" />;
    default:
      return <></>;
  }
};

export default getCreditCardKindIcon;
